// extracted by mini-css-extract-plugin
export default {"container":"Giving_container__LPsNr","card":"Giving_card__XZQSg","row":"Giving_row__inZWO","yellow":"Giving_yellow__zg4rO"};